import { render, staticRenderFns } from "./ChangeGiftModal.vue?vue&type=template&id=a31c82a2"
import script from "./ChangeGiftModal.vue?vue&type=script&lang=js"
export * from "./ChangeGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports